import { AnchorNode } from './AnchorNode';
import { Selector } from './Selector';

export const resolveAnchorPath = (root: AnchorNode, path: string, strict = true) => {
    const selectorPath = Selector.parsePath(path);
    let matches = root.all();

    for (let curLevel = 0, maxLevel = selectorPath.length; curLevel < maxLevel; curLevel++) {
        matches = matches.filter((anchor) => {
            // go up N levels
            for (let i = 0; i < curLevel && anchor; i++) { anchor = anchor.parent; }
            if (anchor) {
                return anchor.identifier === selectorPath[maxLevel - curLevel - 1].identifier
                    && anchor.num === selectorPath[maxLevel - curLevel - 1].num;
            }
        });
        if (!strict && matches.length === 1) {
            // one result and loose search? we are done.
            return matches;
        }
    }
    return matches;
};



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/anchor/resolveAnchorPath.tsx